import React, {useState} from 'react'

import {useSubscription} from '@/shared/utils/SubscriptionProvider'
import {CatalogModule} from './catalog'
import {QuotePurchaseKind, QuoteRequestDialog} from './QuoteRequestDialog'

interface SubscriptionQuoteButtonProps {
  kind: QuotePurchaseKind
  label: string
  className: string
  /** Modules pre-ticked in an `add_module` dialog. */
  initialModules?: CatalogModule[]
}

/**
 * A button that opens the quote-request dialog (renew / add modules / add seats) for the active
 * subscription — the same dialog as the Settings page, for entry points outside it such as the AI
 * chat paywall and composer banner.
 */
export const SubscriptionQuoteButton: React.FC<SubscriptionQuoteButtonProps> = ({
  kind,
  label,
  className,
  initialModules,
}) => {
  const {subscriptionId, subscriptionDetails} = useSubscription()
  const [open, setOpen] = useState(false)

  return (
    <>
      <button type='button' className={className} onClick={() => setOpen(true)}>
        {label}
      </button>
      {open && (
        <QuoteRequestDialog
          kind={kind}
          subscriptionId={subscriptionId}
          ownedModules={subscriptionDetails?.modules}
          initialModules={initialModules}
          closeModal={() => setOpen(false)}
        />
      )}
    </>
  )
}
